import React, { InputHTMLAttributes } from "react";
import { Text } from "rebass";

import { SwitchCheckbox as StyledSwitchCheckbox } from "../styled/SwitchCheckbox";
import { SwitchLabel } from "./SwitchLabel";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  checked: boolean;
}

export const SwitchCheckbox: React.FC<IProps> = (
  {
    label,
    checked,
    disabled = false,
    onChange
  }
) => (
  <SwitchLabel isDisabled={disabled}>
    <Text
      fontSize="18px"
      fontWeight={400}
    >
      {label}
    </Text>

    <StyledSwitchCheckbox checked={checked} />

    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      hidden
    />
  </SwitchLabel>
);
